import style from "components/global/description/style";

const AboutHomeDescription = ({ description, length }) => {
  const classes = style();
  const styles = {
    fontSize: "14px !important",
    color: "blue !important",
    //  backgroundColor: 'red'
  };

  return (
    <>
      <div
        style={{ ...styles }}
      //   className={`${length ? classes.lineClampDesc : classes.lineClamp}`}
        className={ classes.lineClampDescAboutHome}
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </>
  );
};

export default AboutHomeDescription;
